/**
 * This Api class lets you define an API endpoint and methods to request
 * data and process it.
 *
 * See the [Backend API Integration](https://github.com/infinitered/ignite/blob/master/docs/Backend-API-Integration.md)
 * documentation for more details.
 */
import { ApisauceInstance, create } from 'apisauce';
import { load } from '../../utils/storage';
import type { ApiConfig } from './api.types';

const { REACT_APP_AUTH_URL, REACT_APP_BASE_URL } = process.env;

/**
 * Configuring the apisauce instance.
 */
export const DEFAULT_API_CONFIG: ApiConfig = {
  url: REACT_APP_BASE_URL ?? '',
  timeout: 10000,
};

/**
 * Manages all requests to the API. You can use this class to build out
 * various requests that you need to call from your backend API.
 */

export const generateAuthApiClient = () => {
  const config: ApiConfig = DEFAULT_API_CONFIG;
  const api: ApisauceInstance = create({
    baseURL: REACT_APP_AUTH_URL,
    timeout: config.timeout,
    headers: {
      'Content-Type': 'application/json',
      Application: 'DarAbiTayyab',
    },
  });
  return api;
};

export const generateApiClient = () => {
  const config: ApiConfig = DEFAULT_API_CONFIG;
  const api: ApisauceInstance = create({
    baseURL: config.url,
    timeout: config.timeout,
    headers: {
      'Content-Type': 'application/json',
      Application: 'DarAbiTayyab',
      'Accept-Language': 'en',
    },
  });
  api.addAsyncRequestTransform((request) => async () => {
    // Get Access token from local storge and add it to headers

    if (request.headers) {
      const accessToken = await load('@accessToken');
      if (accessToken) {
        request.headers.Authorization = `Bearer ${accessToken}`;
      } else {
        request.headers.Authorization = ``;
      }
    }
  });
  return api;
};
// Singleton instance of the API for convenience
// export const api = new Api()
export const api = generateApiClient();
